// Moved from workspace/components/AppGlyphTile.js (unit 2, 27bb58d37) into the shared kit in unit 3: the navbar
// tabs (shared/components/HeaderTabs.js) wear it too, so it cannot live in one app's package.
// THE GLYPH PLATE (dropdowns spec 2026-09-30 §4, §5) — the plate of the NEW glyph language: a square with a
// hairline ring at rest (the one stroke the redesign allows, after Nika's hairline tile references) and the
// glyph in title ink. It never styles its own states: the HOLDER does, through the `data-glyph-plate` hook
// (the MenuPanelItem keycap pattern) — hover, keyboard focus and "the app you are in" INVERT the plate
// (`highlight` fill, `title-reversed` ink); `[aria-current="page"]` on the holder also shows the orange dot.
// The search launcher wears it with the PIXEL glyphs (iconXl = two screen pixels per cell).
//
//   IconTile: { extends: 'AppGlyphPlate' }   — the launcher: the PIXEL glyph of the tile row (`s`)
//   Glyph: { extends: 'AppGlyphPlate', Icon: { name: (el, s) => el.call('glyphNameFor', {…}, 'ln') } }
//                                            — the navigation names its LINE glyph at the mount
export const AppGlyphPlate = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: '0',
  boxSizing: 'border-box',
  boxSize: 'glyphPlate',
  minWidth: 'glyphPlate',
  round: 'radiusControl',
  borderWidth: 'hairline',
  borderStyle: 'solid',
  borderColor: 'line',
  background: 'transparent',
  color: 'title',
  dataGlyphPlate: true,
  transition:
    'background-color A defaultBezier, color A defaultBezier, border-color A defaultBezier',
  Icon: {
    name: (el, s) => el.call('glyphNameFor', s, 'px'),
    boxSize: 'iconXl'
  },
  // "you are here" — shown by the holder's `[aria-current="page"]` rule, hidden otherwise (a FILL hue, the
  // one colour of the language)
  Dot: {
    tag: 'span',
    dataGlyphDot: true,
    ariaHidden: 'true',
    display: 'none',
    position: 'absolute',
    top: '-X',
    right: '-X',
    boxSize: 'glyphDot',
    round: 'radiusPill',
    background: 'orange'
  }
}

// THE HOLDER RULES — the one state logic of a glyph plate, written ONCE (design-d2 on a1d920d0c: the four rules
// stood verbatim in HeaderTab, MobileTab and the App strip's Open button). A control that holds a plate puts this
// in its `extends`: hover, keyboard focus and "the page / app you are in" INVERT the plate; the current one also
// shows the dot. Rules in an extends list reach the holder (proved by design-d2 on the real create()).
export const GlyphPlateHolder = {
  '&:hover [data-glyph-plate]': {
    background: 'highlight',
    color: 'title-reversed',
    borderColor: 'highlight'
  },
  '&:focus-visible [data-glyph-plate]': {
    background: 'highlight',
    color: 'title-reversed',
    borderColor: 'highlight'
  },
  '&[aria-current="page"] [data-glyph-plate]': {
    background: 'highlight',
    color: 'title-reversed',
    borderColor: 'highlight'
  },
  '&[aria-current="page"] [data-glyph-dot]': { display: 'block' }
}

// THE NAVBAR TAB'S PLATE (dropdowns spec §12.3): 24 px, round, ringless at rest in the dense bar, before the label
// text (`order: -1`, the MenuPanelItem Icon pattern), the tab's LINE glyph through the one resolver — by its path,
// the module's own icon key when the house set carries it, then the words of its name and app key (Nika
// 2026-10-23: "make better icons": a module tab reads as itself, never as the shared app window when a house glyph
// fits it — functions/glyphNames.js).
export const NavTabGlyph = {
  extends: 'AppGlyphPlate',
  order: '-1',
  boxSize: 'glyphPlateXs',
  minWidth: 'glyphPlateXs',
  round: 'radiusPill',
  borderColor: 'transparent',
  Icon: {
    name: (el, s) =>
      el.call(
        'glyphNameFor',
        {
          route: s && s.path,
          icon: s && s.icon,
          glyph: s && s.icon,
          label: s && s.label,
          appKey: s && s.appKey
        },
        'ln'
      ),
    boxSize: 'iconSm'
  }
}
